import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { UIDid } from 'src/app/components/dids/dids.model';
import { DidsService } from 'src/app/components/dids/dids.service';

@Component({
  selector: 'app-filter-did',
  templateUrl: './filter-did.component.html',
  styleUrls: ['./filter-did.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterDidComponent),
      multi: true,
    },
  ],
})
export class FilterDidComponent implements ControlValueAccessor {
  public value: string;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: any = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouch: any = () => {};

  public dids: UIDid[];
  public selectedDid: UIDid;

  constructor(private didsService: DidsService) {
    this.dids = this.didsService.getCachedDids();
  }

  public selectDid(did: UIDid) {
    this.selectedDid = did;
    this.onChange(did);
  }

  writeValue(obj: string): void {
    if (obj) {
      this.selectedDid = this.dids.find((did) => did.number === obj);
      this.onChange(this.selectedDid);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
}
